import {
  Avatar,
  HStack,
  Stack,
  Box,
  Text,
  Image,
} from "@chakra-ui/react";
import React from "react";
import { BsFillCheckCircleFill, BsFillStarFill } from "react-icons/bs";
import { BiTime } from "react-icons/bi";
import { ImProfile } from "react-icons/im";
import ContactPopup from "./ContactPopup";

export default function Profile() {
  return (
    <Box
      border="1px solid gray"
      borderRadius={10}
      overflow="hidden"
      my={8}
      p={5}
    >
      <HStack justify="end">
        <Image src="/images/verified.png" />
      </HStack>
      <Stack alignItems="center" gap={2}>
        <Avatar
          src="/images/freelancer/profiles/6.png"
          size="xl"
          alignItems="start"
          pos="relative"
        >
           <Box
                as="span"
                pos="absolute"
                // left="-12px"
                right="10px"
                top="6px"
                p="6px"
                fontSize="xs"
                fontWeight="bold"
                lineHeight="none"
                color="green.100"
                // transform="translate(50%,-50%)"
                bg="#00D900"
                rounded="full"
              />
        </Avatar>
        <HStack color="#0079BC">
          <Text fontWeight="bold">Logo Master</Text>
          <BsFillCheckCircleFill />
        </HStack>
        <HStack>
          <Box color="#FFBE5B">
            <BsFillStarFill />
          </Box>
          <Text fontWeight="bold">4.8</Text>
          <Text color="gray.500" fontWeight="bold">
            (2k)
          </Text>
        </HStack>
        <HStack gap={5} fontSize={{ base: "11px", md: "16px" }}>
          <Stack alignItems="center">
            <Image src="/images/gigImage/us-flag.png" w="26px" />
            <Text color="#909090">United States</Text>
          </Stack>
          <Stack alignItems="center">
            <Box color="brand.400">
              <ImProfile size="26px" />
            </Box>
            <Text color="#909090">Feb 2022</Text>
          </Stack>
          <Stack alignItems="center">
            <Box color="brand.400">
              <BiTime size="26px" />
            </Box>
            <Text color="#909090">1 Hour</Text>
          </Stack>
        </HStack>
        <Text
          fontSize={{ base: "16px", md: "19px" }}
          fontWeight={500}
          maxW="460px"
          color="#909090"
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur nec
          mattis ex. Etiam porttitor urna
        </Text>
        <Box py={2}>
          <ContactPopup />
        </Box>
      </Stack>
    </Box>
  );
}
